import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Lock } from "lucide-react";
import Logo from "@/components/Logo";
import { api, setToken, errorMessage } from "@/lib/adminApi";

export const FIELD =
    "w-full rounded-xl border border-input bg-surface px-4 py-3 text-sm outline-none transition-colors duration-200 placeholder:text-muted-foreground focus:border-primary";

export default function AdminLogin({ onSuccess }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        try {
            const { data } = await api.post("/auth/login", { email, password });
            setToken(data.token);
            onSuccess(data.user);
        } catch (err) {
            setError(errorMessage(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center px-5">
            <div className="w-full max-w-sm">
                <Logo className="h-14" />
                <h1 className="mt-8 font-display text-3xl font-extrabold tracking-tight">Admin sign in</h1>
                <p className="mt-2 text-sm text-muted-foreground">Review moderation and quote requests.</p>

                <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
                    <input
                        type="email"
                        required
                        autoComplete="username"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className={FIELD}
                        data-testid="admin-email-input"
                    />
                    <input
                        type="password"
                        required
                        autoComplete="current-password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className={FIELD}
                        data-testid="admin-password-input"
                    />
                    {error && (
                        <p className="rounded-lg border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive" data-testid="admin-login-error">
                            {error}
                        </p>
                    )}
                    <button
                        type="submit"
                        disabled={busy}
                        data-testid="admin-login-submit"
                        className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary py-3 text-sm font-bold text-primary-foreground transition-transform duration-200 hover:scale-[1.02] active:scale-95 disabled:opacity-50"
                    >
                        <Lock size={14} />
                        {busy ? "Signing in…" : "Sign in"}
                    </button>
                </form>

                <Link to="/" className="mt-8 inline-flex items-center gap-1.5 text-xs text-muted-foreground transition-colors hover:text-primary" data-testid="admin-back-home">
                    <ArrowLeft size={13} /> Back to site
                </Link>
            </div>
        </div>
    );
}
